import kSidebar from "./../sidebar"
window.kSidebar = kSidebar
